
window.wdc = function(elemstr) 
{
  elemstr = elemstr.trim();
  
  // If starts with '<', parse as HTML
  if (elemstr.startsWith('<'))
  {
    // Use template element for safe, efficient HTML parsing
    const template = document.createElement('template');
    template.innerHTML = elemstr;
    return template.content.firstChild;
  }
  
  // Otherwise treat as CSS selector
  return document.querySelector(elemstr);
};

window.wdEmpty = function(elem)
{
  while (elem.firstChild)
  {
    elem.firstChild.remove();
  }
}